var _path, _circle, _path2, _rect, _rect2, _line, _line2, _line3, _circle2, _path3, _rect3, _rect4, _line4, _line5, _line6, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourLongMiddleFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 10 C 35 10, 170 45, 200 60 L 200 140 C 170 155, 35 190, 0 190 ",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 100,
    r: 35,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 73 L 165 78 L 165 122 L 90 127 Z",
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 63,
    height: 15,
    width: 10,
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 122,
    height: 15,
    width: 10,
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 89,
    x2: 195,
    y2: 89,
    strokeWidth: 3,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 100,
    x2: 195,
    y2: 100,
    strokeWidth: 3,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 111,
    x2: 195,
    y2: 111,
    strokeWidth: 3,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 100,
    r: 35,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 73 L 75 78 L 75 122 L 0 127 Z",
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 63,
    height: 15,
    width: 10,
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 122,
    height: 15,
    width: 10,
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 89,
    x2: 105,
    y2: 89,
    strokeWidth: 3,
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 100,
    x2: 105,
    y2: 100,
    strokeWidth: 3,
    stroke: "black"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 111,
    x2: 105,
    y2: 111,
    strokeWidth: 3,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 165,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 150,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 35,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 50,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 155,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 148,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 45,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 52,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 70,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 130,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 50,
    height: 10,
    width: 10,
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 140,
    height: 10,
    width: 10,
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), "\n\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourLongMiddleFront);
export default __webpack_public_path__ + "static/media/FourLongMiddleFront.ef96b71781b9acee15ec77d42fa15490.svg";
export { ForwardRef as ReactComponent };